export default "__VITE_ASSET__Ct0Z9zT5__"